import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
import { Label } from "../styled";

import {
  CustomSelect,
  Input,
  InputGroup,
  AutoSaveField as Field,
  LinkedField
} from "../../../../components/Form";
import { getOrgKYCDetails, getApplicantInfo } from "../../../../store/selectors/appConfig";
import { UAE_CODE, MAX_EMAIL_LENGTH } from "../../../../constants";

export const CompanyPreferredContactInformationComponent = ({
  chequeBookApplied,
  primaryPhoneNo,
  setFieldValue
}) => {
  const applicantInfo = useSelector(getApplicantInfo) || {};
  const orgKYCDetails = useSelector(getOrgKYCDetails) || {};
  const contactDetails = orgKYCDetails.contactDetails || {};
  const countryCode = applicantInfo?.countryCode ?? "";
  const email = applicantInfo?.email ?? "";
  const mobileNo = applicantInfo?.mobileNo ?? "";
  useEffect(() => {
    if (email && contactDetails.primaryEmail === "") {
      setFieldValue("primaryEmail", email);
    }

    // Only set mobile number if applicantInfo exists and has a mobileNo property
    if (mobileNo && contactDetails.mobileNo === "") {
      setFieldValue("primaryMobileNo", mobileNo);
      setFieldValue(
        "primaryMobCountryCode",
        contactDetails.mobileNo === mobileNo ? countryCode || UAE_CODE : UAE_CODE
      );
    }
  }, [
    countryCode,
    email,
    mobileNo,
    contactDetails.mobileNo,
    contactDetails.primaryEmail,
    setFieldValue
  ]);

  return (
    <React.Fragment>
      <Grid container spacing={3} sx={{ mt: 0, rowGap: "16px" }}>
        <Grid item xs={12}>
          <Label>Contact</Label>
        </Grid>
        <Grid item xs={12}>
          <Field
            name="primaryEmail"
            path="prospect.orgKYCDetails.contactDetails.primaryEmail"
            label="Primary e-mail address"
            placeholder="Primary e-mail address"
            component={Input}
            InputProps={{
              inputProps: { maxLength: MAX_EMAIL_LENGTH, tabIndex: 0 }
            }}
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={3}
        sx={{
          mt: 0
        }}
      >
        <Grid item sm={6} xs={12}>
          <InputGroup>
            <LinkedField
              name="primaryMobCountryCode"
              linkedFieldName="primaryMobileNo"
              path="prospect.orgKYCDetails.contactDetails.mobileCountryCode"
              linkedPath="prospect.orgKYCDetails.contactDetails.mobileNo"
              datalistId="countryCode"
              shrink={false}
              component={CustomSelect}
              changeProspect={(prospect, value) =>
                value !== UAE_CODE && chequeBookApplied
                  ? { ...prospect, "prospect.accountInfo[0].chequeBookApplied": false }
                  : prospect
              }
              inputProps={{ tabIndex: 0 }}
            />
            <LinkedField
              name="primaryMobileNo"
              linkedFieldName="primaryMobCountryCode"
              path="prospect.orgKYCDetails.contactDetails.mobileNo"
              linkedPath="prospect.orgKYCDetails.contactDetails.mobileCountryCode"
              label="Mobile number"
              placeholder="55xxxxxxx"
              component={Input}
              contextualHelpText="This number will be used as primary contact for Transaction Alerts and queries related to Business. If you give an international number, then Cheque book will not be issued."
              InputProps={{
                inputProps: { tabIndex: 0 }
              }}
            />
          </InputGroup>
        </Grid>
        <Grid
          item
          sm={6}
          xs={12}
          sx={{
            mt: {
              xs: 2,
              sm: 0
            }
          }}
        >
          <InputGroup>
            <LinkedField
              name="primaryPhoneCountryCode"
              linkedFieldName="primaryPhoneNo"
              path="prospect.orgKYCDetails.contactDetails.phoneCountryCode"
              linkedPath="prospect.orgKYCDetails.contactDetails.phoneNo"
              component={CustomSelect}
              datalistId="countryCode"
              shrink={false}
              inputProps={{ tabIndex: 0 }}
            />

            <LinkedField
              name="primaryPhoneNo"
              linkedFieldName="primaryPhoneCountryCode"
              path="prospect.orgKYCDetails.contactDetails.phoneNo"
              linkedPath="prospect.orgKYCDetails.contactDetails.phoneCountryCode"
              label="Landline number"
              placeholder="42xxxxxx"
              component={Input}
              InputProps={{
                inputProps: { tabIndex: 0 }
              }}
            />
          </InputGroup>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

CompanyPreferredContactInformationComponent.propTypes = {
  chequeBookApplied: PropTypes.bool,
  primaryPhoneNo: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired
};
